"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("regenerator-runtime");
require("@fontsource/newsreader/index.css");
require("@fontsource/newsreader/variable-italic.css");
require("./index.scss");
require("highlight.js/styles/github.css");
const setup_1 = __importDefault(require("./setup"));
setup_1.default();
if (module.hot) {
    module.hot.accept();
}
